
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-instagram_2",attrs:{"fill":"#798f8f"}},[_c('path',{staticClass:"i-Vector",attrs:{"d":"M8.786 2.301c2.112 0 2.363 0 3.219.045.502.008.998.102 1.468.277.343.127.654.33.908.593.263.254.466.564.592.908.176.47.27.966.277 1.468.033.83.045 1.082.045 3.22 0 2.137 0 2.362-.045 3.219a4.379 4.379 0 0 1-.277 1.468 2.634 2.634 0 0 1-1.5 1.5c-.47.176-.966.27-1.468.277-.83.032-1.082.045-3.22.045-2.137 0-2.363 0-3.219-.045A4.379 4.379 0 0 1 4.098 15a2.44 2.44 0 0 1-.908-.592 2.44 2.44 0 0 1-.592-.908 4.379 4.379 0 0 1-.277-1.468c0-.83-.045-1.082-.045-3.22 0-2.137 0-2.363.045-3.22.007-.5.1-.997.277-1.467a2.44 2.44 0 0 1 .592-.908 2.44 2.44 0 0 1 .908-.593 4.379 4.379 0 0 1 1.494-.277c.83 0 1.082-.045 3.22-.045h-.026ZM8.81.878c-2.144 0-2.414 0-3.258.045a5.673 5.673 0 0 0-1.932.374 3.863 3.863 0 0 0-1.416.908 3.863 3.863 0 0 0-.908 1.404A5.673 5.673 0 0 0 .923 5.54C.891 6.37.878 6.641.878 8.786c0 2.144 0 2.414.045 3.258.011.66.138 1.314.374 1.931.197.529.506 1.008.908 1.404.396.402.875.711 1.404.908a5.676 5.676 0 0 0 1.931.373c.844.033 1.114.046 3.258.046 2.145 0 2.415 0 3.258-.046a5.676 5.676 0 0 0 1.932-.373 3.987 3.987 0 0 0 2.312-2.312 5.674 5.674 0 0 0 .373-1.931c.033-.844.045-1.114.045-3.258 0-2.145 0-2.415-.045-3.259a5.673 5.673 0 0 0-.373-1.931 3.865 3.865 0 0 0-2.338-2.3 5.673 5.673 0 0 0-1.931-.373C11.2.891 10.93.878 8.786.878h.025Z"}}),_c('path',{staticClass:"i-Vector_2",attrs:{"d":"M8.786 4.723a4.063 4.063 0 1 0 4.063 4.063 4.07 4.07 0 0 0-4.063-4.063Zm0 6.696a2.634 2.634 0 1 1 0-5.268 2.634 2.634 0 0 1 0 5.268Z"}}),_c('path',{staticClass:"i-Vector_3",attrs:{"d":"M13.003 5.514a.947.947 0 1 0 0-1.893.947.947 0 0 0 0 1.893Z"}})])])
          )
        }
      }
    